export default __webpack_public_path__ + "assets/images/a6b1be5281f5c72224e16fb3a43799c8.png";